module.exports = __webpack_public_path__ + "media/images/new_landing/logos/uber-778f7a2932b390b5df2782bdd44b3bf3.png";